/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceFcmUpdateRequest } from '../../models/device-fcm-update-request';

export interface UpdatePushTokenDeprecated$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: DeviceFcmUpdateRequest
}

export function updatePushTokenDeprecated(http: HttpClient, rootUrl: string, params: UpdatePushTokenDeprecated$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, updatePushTokenDeprecated.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

updatePushTokenDeprecated.PATH = '/api/v1/devices/{id}/update_pushtoken';
